import cn from "classnames";
import React from "react";

const TableTab = ({
  handleClick,
  isActiveTab,
  tabName,
  tabIcon,
  currentTab,
}) => {
  return (
    <button
      className={cn(
        "py-2 px-2 lg:px-0 lg:pl-3 lg:pr-4 flex transition-colors duration-300 hover:bg-[#F0F4FF] dark:hover:bg-darkButBg items-center gap-1 lg:gap-2 justify-center w-full  lg:w-fit rounded-lg",
        {
          "border border-white bg-lightBlue shadow-swapButton dark:border-opacity-15 dark:bg-darkButBg":
            currentTab.value === isActiveTab,
        }
      )}
      type="button"
      onClick={() => handleClick(currentTab.value)}
    >
      <span className="w-5 h-5  items-center justify-center lg:flex">
        {tabIcon}
      </span>
      <p
        className={cn(
          "text-xs md:text-sm font-medium leading-[21px] text-semiBlack dark:text-semiWhite",
          {
            "!text-black dark:!text-white ": currentTab.value === isActiveTab,
          }
        )}
      >
        {tabName}
      </p>
    </button>
  );
};

export default TableTab;
